module.exports = __webpack_public_path__ + "static/media/logvpa.d792b27b.png";